import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  public mitData = [
    {
      copyright: ["Copyright (c) 2010-2019 Google LLC."],
      items: [
        { name: "@angular/animations", version: "~8.2.14" },
        { name: "@angular/common", version: "~8.2.14" },
        { name: "@angular/compiler", version: "~8.2.14" },
        { name: "@angular/core", version: "~8.2.14" },
        { name: "@angular/forms", version: "~8.2.14" },
        { name: "@angular/platform-browser", version: "~8.2.14" },
        { name: "@angular/platform-browser-dynamic", version: "~8.2.14" },
        { name: "@angular/router", version: "~8.2.14" },
        { name: "zone.js", version: "~0.9.1" },
      ],
    },
    {
      copyright: ["Copyright (c) 2015-2018 Angular ng-bootstrap team"],
      items: [{ name: "@ng-bootstrap/ng-bootstrap", version: "^5.1.4" }],
    },
    {
      copyright: ["Copyright (c) 2016 FormlyJS"],
      items: [
        { name: "@ngx-formly/bootstrap", version: "^5.5.8" },
        { name: "@ngx-formly/core", version: "^5.5.7" },
      ],
    },
    {
      copyright: ["Copyright (c) 2018 Olivier Combe"],
      items: [
        { name: "@ngx-translate/core", version: "^11.0.1" },
        {
          name: "@ngx-translate/http-loader",
          version: "^4.0.0",
        },
      ],
    },
    {
      copyright: ["Copyright (c) 2019 Giorgi Merabishvili"],
      items: [{ name: "angular-ng-autocomplete", version: "1.1.16" }],
    },
    {
      items: [{ name: "bootstrap", version: "^4.4.0" }],
      copyright: [
        "Copyright (c) 2011-2019 Twitter, Inc.",
        "Copyright (c) 2011-2019 The Bootstrap Authors",
      ],
    },
    {
      items: [{ name: "file-saver", version: "^2.0.2" }],
      license: "MIT",
      copyright: ["Copyright © 2016 Eli Grey."],
    },
    {
      items: [{ name: "ng5-slider", version: "^1.2.4" }],
      license: "MIT",
      copyright: [
        "Copyright (c) 2013 Rafal Zajac",
        "Copyright (c) 2018 Piotr Dziwinski",
      ],
    },
    {
      items: [{ name: "ngx-pagination", version: "^5.0.0" }],
      license: "MIT",
      copyright: ["Copyright (c) 2016 Michael Bromley"],
    },

    {
      items: [{ name: "sonar-scanner", version: "^3.1.0" }],
      copyright: ["NA"],
    },
    {
      items: [{ name: "jwt-decode", version: "^3.1.2" }],
      copyright: ["Copyright (c) 2015 Auth0, Inc."],
    },
    {
      items: [{ name: "jquery", version: "^3.7.0" }],
      copyright: ["Copyright OpenJS Foundation and other contributors"],
    },
    {
      items: [{ name: "popper.js", version: "^1.16.1" }],
      copyright: ["Copyright © 2016 Federico Zivolo and contributors"],
    },
    {
      items: [{ name: "angular-oauth2-oidc", version: "^8.0.4" }],
      copyright: ["Copyright (c) 2017 Manfred Steyer"],
    },
    {
      items: [{ name: "jsrsasign", version: "11.1.0" }],
      copyright: ["Copyright (c) 2010-2021 Kenji Urushima"],
    },
  ];

  public apacheData = [
    {
      copyright: [
        "Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors",
      ],
      items: [{ name: "rxjs", version: "~6.4.0" }],
    },
    {
      items: [{ name: "tslib", version: "^1.10.0" }],
      copyright: ["NA"],
    },
  ];

  public iscData = [
    {
      items: [
        { name: "d3", version: "^7.8.2" },
        { name: "d3-color", version: "^3.1.0" },
      ],
      copyright: ["Copyright 2010-2023 Mike Bostock"],
    },
  ];

  getTotalItems(data) {
    let count = 0;
    data.forEach((section) => {
      count += section.items.length;
    });
    return count;
  }

  gotToLicenseText(id, event) {
    event.preventDefault();
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  }
}
